import { Box, Text, HStack, Button, ButtonGroup, VStack} from "@chakra-ui/react"
import { LinkAsset } from "@utils/assets"

const NotFound = () => {

    return (
        <Box className="w-full h-screen bg-black">
    
            <Box className="w-full h-full text-center text-white" bgImage={'url(/bg/auth/1.jpg)'}>

                    <Box className="absolute w-full h-full bg-black/25" />

                    <VStack spacing={6} className="relative w-full h-full items-center justify-center z-1 container mx-auto">
                        
                        <Box>
                            <Text className="xl:text-8xl text-5xl font-medium mb-3">Page Not Found</Text>
                            <Text>Oops! The page you’re looking for doesn’t exist.</Text>
                        </Box>

                        <LinkAsset href={'/'} linkProps={{className: '!px-7 !py-4 !text-[15px]'}}>
                            Goto Home
                        </LinkAsset>

                    </VStack>
    
            </Box>
    
        </Box>

    )

}

export default NotFound